import React from "react";
import MagazineCard from "../Cards/MagazineCard";
import "./css/index.css";
import AddCard from "../Cards/AddCard";
import UseCommonCard from "../../hooks/UseCommonCard";
import SaveCard from "../Cards/SaveCard";
import StartCard from "../Cards/StartCard";
import { useNavigate } from "react-router-dom";
import FinishCard from "../Cards/FinishCard";
import ProjectFinishCard from "../Cards/ProjectFinishCard";
import FinishSelectCard from "../Cards/FinishSelectCard";
import ReportCard from "../Cards/ReportCard";
import { ProjectBasicDataType } from "../../interface/interface";
import Emty from "../Emty/Emty";
import Infinite from "../Infinite/Infinite";

interface tagInter {
  title: string;
  type: string;
}

type Props = {
  type:
    | "magazine"
    | "add"
    | "save"
    | "select-user"
    | "report"
    | "start"
    | "finish"
    | "prjt-finish"
    | "line";
  tags: tagInter[];
  data: any[];
  PostRemove: (data: any, id: string) => void;
  ProjectPause: ((id: string) => void) | undefined;
  category: "mtup" | "prjt" | undefined;
  ChangeProjectSts: ((id: string) => void) | undefined;
  __ChangeState:
    | ((
        type: "reject" | "select" | "block" | "reselect",
        data: any
      ) => Promise<boolean>)
    | undefined;
  prjtData: ProjectBasicDataType | undefined;
  PagingUpdate?: () => void;
  PostStateChange?: (
    ctts_id: string,
    ctts_stat_cd: "ctts_sts_nrml" | "ctts_sts_none"
  ) => void;
};

const PostListSection = ({
  type,
  tags,
  data,
  PostRemove,
  ProjectPause,
  category,
  ChangeProjectSts,
  __ChangeState,
  prjtData,
  PagingUpdate,
  PostStateChange,
}: Props) => {
  const navigate = useNavigate();
  const [UpdateBlind, OrderChange, Delete, setDelete] = UseCommonCard({
    data: data,
  });
  return (
    <div className={`post-list-section ${type}-list-section`}>
      <div className={`list-tag-section`}>
        {tags.map(({ title, type }, idx) => {
          return (
            <div className={`list-tag ${type}`} key={idx}>
              {title}
            </div>
          );
        })}
      </div>
      {data.length > 0 ? (
        <>
          <div className="post-list-wrapper">
            {data.map((item, idx) => {
              if (type === "magazine") {
                return (
                  <MagazineCard
                    data={item}
                    key={idx}
                    DeleteIndex={Delete}
                    setDeleteIndex={setDelete}
                    PostRemove={PostRemove}
                    PostStateChange={PostStateChange}
                    index={idx}
                  />
                );
              }
              if (type === "add" || type === "line") {
                return (
                  <AddCard
                    key={idx}
                    index={idx}
                    data={item}
                    DeleteIndex={Delete}
                    setDeleteIndex={setDelete}
                    PostRemove={PostRemove}
                    UpdateBlind={UpdateBlind}
                    OrderChange={OrderChange}
                    type={type}
                  />
                );
              }
              if (type === "save") {
                return (
                  <SaveCard
                    key={idx}
                    index={idx}
                    data={item}
                    DeleteIndex={Delete}
                    setDeleteIndex={setDelete}
                    PostRemove={PostRemove}
                  />
                );
              }
              if (type === "start") {
                return (
                  <StartCard
                    key={idx}
                    index={idx}
                    data={item}
                    DeleteIndex={Delete}
                    setDeleteIndex={setDelete}
                    PostRemove={PostRemove}
                    ProjectPause={ProjectPause}
                    navigate={navigate}
                  />
                );
              }
              if (type === "finish") {
                return (
                  <FinishCard
                    key={idx}
                    index={idx}
                    data={item}
                    navigate={navigate}
                  />
                );
              }
              if (type === "prjt-finish") {
                return (
                  <ProjectFinishCard
                    key={idx}
                    index={idx}
                    data={item}
                    navigate={navigate}
                    ChangeProjectSts={ChangeProjectSts}
                  />
                );
              }
              if (type === "report") {
                return (
                  <ReportCard key={idx} data={item} ReportBlind={PostRemove} />
                );
              }
              if (type === "select-user") {
                return (
                  <FinishSelectCard
                    key={idx}
                    data={item}
                    navigate={navigate}
                    category={category}
                    __ChangeState={__ChangeState}
                    prjtData={prjtData}
                  />
                );
              }
              return <div></div>;
            })}
          </div>
          {PagingUpdate && <Infinite PagingUpdate={PagingUpdate} />}
        </>
      ) : (
        <Emty />
      )}
    </div>
  );
};

export default PostListSection;
